export default __webpack_public_path__ + "static/prizes-20447b0767eb7a66242b5f649ab93374.png";